/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Form } from '../../models/form';
import { FormSubmitDto } from '../../models/form-submit-dto';

export interface SubmitForm$Params {
  formId: string;
  body: FormSubmitDto;
}

export function submitForm(
  http: HttpClient,
  rootUrl: string,
  params: SubmitForm$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Form>> {
  const rb = new RequestBuilder(rootUrl, submitForm.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Form>;
    })
  );
}

submitForm.PATH = '/forms/{formId}/submit';
